import customaxios from ".";
import qs from "qs";
import { PlannerDetailsResponse } from "../features/preneed-planners-details-page/preneed-planners-details-page.types";

export const getPreneedPlannerById = (plannerId: number) => {
  return customaxios({
    method: "GET",
    url: `/preneed-planner/${plannerId}`,
  });
};

export const requestQuote = (partnerId: number, data: any) => {
  return customaxios({
    method: "POST",
    url: `/preneed-planner/request-quote/${partnerId}`,
    data,
  });
};

export const getInitialPlanners = (params: any) => {
  return customaxios({
    method: "GET",
    url: `/preneed-planner/filter-list`,
    params,
  });
};

export const getFilteredPlanners = (params: any) => {
  return customaxios({
    method: "GET",
    url: `/preneed-planner/filter-list`,
    params,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  });
};

export const getPreneedPlannerDetails = (partnerId: number, params: any) => {
  return customaxios<PlannerDetailsResponse>({
    method: "GET",
    url: `/preneed-planner/details/${partnerId}`,
    params
  });
};

export const getPreneedPlannerTestimonials = (partnerId: number) => {
  return customaxios({
    method: "GET",
    url: `/reviews/partner/${partnerId}`,
  });
};

export const togglePlannerFavorite = (partnerId: number) => {
  return customaxios({
    method: "POST",
    url: `/preneed-planner/favorite/${partnerId}`,
  });
};

export const plannerAutoSuggestions = (searchText: string) => {
  return customaxios({
    method: "GET",
    url: `/preneed-planner/search/query/suggestions?text=${searchText}`,
  });
};

export const getPlannerBySearchText = (params: {
  text?: string;
  businessName?: string;
  type?: string;
  state?: string;
  city?: string;
}) => {
  const query = qs.stringify(params);
  return customaxios({
    method: "GET",
    url: `/preneed-planner/search/query/listing?${query}`,
  });
};

export const sharePlannerDetails = (plannerId: number, data: any) => {
  return customaxios({
    method: "POST",
    url: `/preneed-planner/share-details/${plannerId}`,
    data,
  });
};

export const plannerBookConsultation = (plannerId: number, data: any) => {
  return customaxios({
    method: "POST",
    url: `/preneed-planner/book-consultation/free/${plannerId}`,
    data,
  });
};
